import React, { Component } from "react"
import axios, { post } from 'axios'
import { token } from '../../services/authServices'
import { withStyles } from 'material-ui/styles'
import { CircularProgress } from 'material-ui/Progress'
import Dialog, {
	DialogTitle,
	DialogContent,
	DialogActions
} from 'material-ui/Dialog'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Table, {
	TableBody,
	TableCell,
	TableHead,
	TableRow
} from 'material-ui/Table'

const apiBaseUrl = process.env.API_URL
const styles = {
	progressWrapper: {
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		alignItems: 'center',
	},
	progress: {
	},
	textField: {
		display: 'block'
	},
	dialogActions: {
		justifyContent: 'center'
	},
	titleWrap: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: '22px'
	},
	title: {
		marginRight: '15px',
		color: 'green'
	},
	error: {
		color: 'red',
		fontSize: '36px'
	},
	warning: {
		color: 'yellow'
	},
	done: {
		color: 'green'
	},
	errorMsg: {
		color: 'red'
	}
}

class Import extends Component {
	constructor(props) {
		super(props)

		this.state = {
			'file': null,
			'isFetching': true,
			'open': false,
			'data': {},
			'errors': {}
		}
	}

	onSubmit = e => {
		e.preventDefault()
		this.handleToggleModal(true)

		this.fileUpload(this.state.file).then(res => {
			if (res.data) {
				this.setState({
					'isFetching': false,
					'data': res.data
				})
			}
		}).catch(err => {
			let response = JSON.parse(err.request.response)

			this.setState({
				'isFetching': false,
				'errors': response.errors
			})
		})
	}

	fileUpload = file => {
		const url = `${apiBaseUrl}/admin/accounts/${this.props.accountId}/school/import`
		const requestHeaders = {
			headers: {
				'Content-Type': 'multipart/form-data',
				'Accept': 'application/x.laravel.v1+json',
				'Authorization': token ? 'Bearer ' + token : null
			}
		}
		const formData = new FormData()

		formData.append('file', file)

		return post(url, formData, requestHeaders)
	}

	handleChange = e => {
		this.setState({ 'file': e.target.files[0] })
	}

	handleToggleModal = bool => {
		if (!bool)
			this.setState({
				'file': null,
				'isFetching': true,
				'open': false,
				'errors': {}
			})

		this.setState({ 'open': bool })
	}

	renderTitle = data => {
		if (!data.success)
			return (
				data.created > 0 || data.updated > 0 ?
					<div>
						<div className={this.classes.titleWrap}>
							<p className={this.classes.title}>
								Import successfully completed
							</p>
							<Icon className={this.classes.warning}>
								warning
							</Icon>
						</div>
						<span>Created: </span>
						<span>{data.created}, </span>
						<span>Updated: </span>
						<span>{data.updated}, </span>
						<span>Errors: </span>
						<span>{data.errors.length}</span>
					</div>
					:
					<div>
						<Icon className={this.classes.error}>
							error
						</Icon>
						<p>
							There is no data to import.
							Please check csv file.
						</p>
					</div>
			)

		return (
			<div>
				<div className={this.classes.titleWrap}>
					<p className={this.classes.title}>
						Import successfully completed
					</p>
					<Icon className={this.classes.done}>
						done
					</Icon>
				</div>
				<span>Created: </span>
				<span>{data.created}, </span>
				<span>Updated: </span>
				<span>{data.updated}</span>
			</div>
		)
	}

	renderTable = isErrors => {
		if (!isErrors)
			return false

		return (
			<Table>
				<TableHead>
					<TableRow>
						<TableCell
							padding="none">
							FIRST NAME
						</TableCell>
						<TableCell
							padding="none">
							LAST NAME
						</TableCell>
						<TableCell
							padding="none">
							PLAYER NAME
						</TableCell>
						<TableCell
							padding="none">
							PASSWORD
						</TableCell>
						<TableCell
							padding="none">
							CLASS NAME
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{this.renderErrorsList()}
				</TableBody>
			</Table>
		)
	}

	renderErrorsList = () => {
		let data = this.state.data
		let result = []

		if (data.errors && data.errors.length) {
			data.errors.map((item, index) => {
				result.push(
					<TableRow key={index}>
						<TableCell padding="none">
							<p>{item.first_name}</p>
							{
								item.errors.first_name ?
									<p className={this.classes.errorMsg}>
										{item.errors.first_name[0]}
									</p>
									: null
							}
						</TableCell>
						<TableCell padding="none">
							<p>{item.last_name}</p>
							{
								item.errors.last_name ?
									<p className={this.classes.errorMsg}>
										{item.errors.last_name[0]}
									</p>
									: null
							}
						</TableCell>
						<TableCell padding="none">
							<p>{item.player_name}</p>
							{
								item.errors.player_name ?
									<p className={this.classes.errorMsg}>
										{item.errors.player_name[0]}
									</p>
									: null
							}
						</TableCell>
						<TableCell padding="none">
							<p>{item.password}</p>
							{
								item.errors.password ?
									<p className={this.classes.errorMsg}>
										{item.errors.password[0]}
									</p>
									: null
							}
						</TableCell>
						<TableCell padding="none">
							<p>{item.class_name}</p>
							{
								item.errors.class_name ?
									<p className={this.classes.errorMsg}>
										{item.errors.class_name[0]}
									</p>
									: null
							}
						</TableCell>
						<TableCell padding="none">
							<p>{item.maths_circle_id}</p>
							{
								item.errors.maths_circle_id ?
									<p className={this.classes.errorMsg}>
										{item.errors.maths_circle_id[0]}
									</p>
									: null
							}
						</TableCell>
					</TableRow>
				)
			})
		}

		return result.map(item => item)
	}

	classes = this.props.classes

	render() {
		const { file, isFetching, open, data, errors } = this.state
		let disable = !file
		let importErrors = data.errors && data.errors.length

		return (
			<div>
				<Dialog fullScreen={importErrors} open={open}>
					<DialogTitle>
						{isFetching ? 'uploading...' : ''}
					</DialogTitle>
					<DialogContent className="align-center">
						{
							isFetching ?
								<div className={this.classes.progressWrapper}>
									<CircularProgress
										className={this.classes.progress}
										size={50}
									/>
								</div>
								:
								<div>
									{this.renderTitle(data)}
									{this.renderTable(importErrors)}
									{errors && errors.file ?
										<div>
											<Icon className={this.classes.error}>
												error
										</Icon>
											<p>{errors.file[0]}</p>
										</div>
										: null}
									<DialogActions
										className={this.classes.dialogActions}>
										<Button
											variant="raised"
											color="primary"
											onClick={
												() => this.handleToggleModal(false)
											}>
											Ok
									</Button>
									</DialogActions>
								</div>
						}
					</DialogContent>
				</Dialog>
				<input
					type="file"
					accept=".csv"
					onChange={this.handleChange}
				/>
				<Button
					variant="raised"
					color="default"
					disabled={disable}
					onClick={this.onSubmit}>
					Upload
					<Icon>
						file_upload
					</Icon>
				</Button>
			</div>
		)
	}
}

export default withStyles(styles)(Import)



// WEBPACK FOOTER //
// ./src/components/content/Import.js